var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.pages),function(item,i){return _c('div',{key:i,staticClass:"page flex-center"},[_c('img',{ref:"img",refInFor:true,attrs:{"src":item}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }